module.exports = __webpack_public_path__ + "img/yellowTulip.0f57b334.jpg";